export enum FeatureToggle {
  TaskManagement = 'INIT-577_TaskManagementMobile'
}



// WEBPACK FOOTER //
// ./src/shared/enum/featureToggle.ts